module.exports = __webpack_public_path__ + "media/fonts/fa-brands-400-a5adc6c0b4316e224269828be6535bb4.ttf";